export default "__VITE_ASSET__Dvg9MTT7__"